import React, { Fragment, useState } from "react";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { HomeWork, Cancel } from "@material-ui/icons/";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

import cardBodyStyle from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

function LocationMatch(props) {
  const classes = useStyles();
  const [showingInfoWindow, setShowingInfoWindow] = useState(false);
  const [activeMarker, setActiveMarker] = useState({});
  const [selectedPlace, setSelectedPlace] = useState({});

  const coords = { lat: props.latitude, lng: props.longitude };

  const onMarkerClick = (prop, marker) => {
    setSelectedPlace(prop);
    setShowingInfoWindow(true);
    setActiveMarker(marker);
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const displayMarkers = () => {
    return (
      <Marker
        key={props.id}
        id={props.id}
        position={{
          lat: parseFloat(props.latitude),
          lng: parseFloat(props.longitude),
        }}
        disableDefaultUI={true}
        name={props.nombre}
        onClick={onMarkerClick}
      />
    );
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        scroll="body"
        keepMounted
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <br></br>
          <Grid container className={classes.containerMap}>
            <Grid item xs={12} sm={12}>
              <Map
                google={props.google}
                zoom={10}
                style={{ height: "300px" }}
                initialCenter={coords}
              >
                {displayMarkers()}

                {showingInfoWindow ? (
                  <InfoWindow marker={activeMarker} visible={showingInfoWindow}>
                    <div>
                      <Typography align="center" variant="subtitle1">
                        <HomeWork />
                        &nbsp;&nbsp;
                        {selectedPlace.name}
                      </Typography>
                    </div>
                  </InfoWindow>
                ) : (
                  ""
                )}
              </Map>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog(true)}>
            <Cancel />
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyDy8AE5RqF-ozGiI8J7r-U1vnb3AwQCY-o",
  //LoadingContainer: LoadingContainer,
  libraries: ["visualization"],
})(LocationMatch);
